/**
 * Determines the status filter based on is_active and is_static combination.
 *
 * Filter logic:
 * - Both true: use is_active_or_static (union of active OR static)
 * - Active only: is_active=true, is_static=false (exclude static accounts)
 * - Static only: is_static=true (include only static accounts)
 * - Neither: no filter
 */
export const getStatusFilters = ({
  isActive,
  isStatic,
}: {
  isActive: boolean | null | undefined;
  isStatic: boolean | null | undefined;
}): {
  is_active_or_static?: boolean;
  is_active?: boolean;
  is_static?: boolean;
} => {
  if (isActive && isStatic) {
    return { is_active_or_static: true };
  }
  if (isActive && !isStatic) {
    return { is_active: true, is_static: false };
  }
  if (!isActive && isStatic) {
    return { is_static: true };
  }
  return {};
};
